import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Form
} from "reactstrap";
import { QuestionIcon, EducationQuestionIcon } from "./ruleIcon";
import Link from "components/ExtendLink";
import { NavLink } from "reactstrap";
import { ROLES } from "../../constants/role.constant";

const ToggleModel = (props) => (
  <Modal
    isOpen={props.modal}
    toggle={props.toggleModal}
    className="bastaLang modal-md"
  >
    <Form onSubmit={props.onSubmitOffer}>
      <ModalHeader toggle={props.toggleModal}>Select Type</ModalHeader>

      <ModalBody style={{ backgroundColor: "white" }}>
        <div className="row text-center">
          {props.userDetails && props.userDetails.role == ROLES.careprovider && <div className="col-4">
            <NavLink
              tag={Link}
              to="/create/question"
              className="text-center d-block"
            >
              <img src={QuestionIcon} style={{ height: "70px" }} />
              <span className="menu-title font-weight-bold d-block text-dark" style={{padding:5}}>
                Questionnaire
              </span>
            </NavLink>
          </div>}
          <div className="col-4">
            <NavLink
              tag={Link}
              to="/create/education-question"
              className="text-center d-block"
            >
              <img src={EducationQuestionIcon} style={{ height: "70px" }} />
              <span className="menu-title font-weight-bold d-block text-dark" style={{padding:5}}>
               Educational Questionnaire
              </span>
            </NavLink>
          </div>
        </div>
      </ModalBody>
    </Form>
  </Modal>
);

export default ToggleModel;
